const TOKEN_KEY = "rd_admin_token";
const EMAIL_KEY = "rd_admin_email";
const USER_KEY = "rd_admin_user";

export const saveAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    if (user.email) localStorage.setItem(EMAIL_KEY, user.email);
  }
};

export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getEmail = () => localStorage.getItem(EMAIL_KEY);

export const getUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveUser = (user) => {
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const hasPerm = (permission) => {
  const user = getUser();
  return !!user && Array.isArray(user.permissions) && user.permissions.includes(permission);
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
  localStorage.removeItem(USER_KEY);
};
